// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onto-btn-primary.shepherd-button:hover {
    background-color: var(--gw-button-primary-hover-background);
    color: var(--gw-button-primary-hover-color);
}

.onto-btn-primary.shepherd-button[disabled]{
    opacity: 0.5;
}

.onto-btn-secondary.shepherd-button:hover {
    background-color: var(--gw-button-secondary-hover-background);
    color: var(--gw-button-secondary-hover-color);
}

.shepherd-element {
    border-radius: 0;
    max-width: 500px;
}

.shepherd-content {
    border-radius: 0;
}

.shepherd-header {
    border-radius: 0;
}

.shepherd-header h3 {
    padding-left: 0.5em;
}

.shepherd-text {
    text-align: center;
    min-height: 90px;
    margin-top: 10px;
    overflow-wrap: break-word;
    color: var(--gw-dialog-color);
}

.shepherd-text ol, .shepherd-text ul {
    text-align: left;
}

.shepherd-text code {
    text-align: left;
    display: block;
    height: 120px;
    margin-top: 0.5em;
    color: var(--gw-secondary-base);
    background-color: var(--gw-tertiary-lighter);
    overflow: auto;
    white-space: pre-wrap;
}

.shepherd-has-title .shepherd-content {
    background-color: var(--gw-dialog-background);
    color: var(--gw-dialog-color);
    border: 1px solid var(--gw-dialog-border-color);
}

.shepherd-has-title .shepherd-content .shepherd-header {
    padding-top: 0.5em;
    padding-bottom: 0.5em;
    background-color: var(--gw-dialog-background);
    color: inherit;
    border-bottom: 1px solid var(--gw-dialog-border-color);
}

.shepherd-has-title .shepherd-content .shepherd-title {
    color: inherit;
}

.shepherd-has-title .shepherd-content .shepherd-cancel-icon {
    color: var(--gw-dialog-color) !important;
}

.shepherd-has-title .shepherd-content .shepherd-cancel-icon:hover {
    color: var(--gw-button-primary-background) !important;
}

.shepherd-footer {
    padding-bottom: 0.5em;
}

.shepherd-arrow:before {
    background-color: var(--gw-dialog-background) !important;
    border: 1px solid var(--gw-dialog-border-color) !important;
}

/*
  Moves the 'Previous' button to the left when it's the only button shown.
  This avoids UX confusion, as primary actions ('Next') is usually on the right.
*/
.shepherd-footer:has(> .shepherd-prev-button:only-child) {
    justify-content: flex-start;
}

.shepherd-progress {
    display: block;
    text-align: right;
    padding-right: 1em;
    font-size: 0.9em;
}

.shepherd-code {
    position: relative;
}

.shepherd-code button {
    position: absolute;
    bottom: 5px;
    right: 20px;
}

.guide-dialog.shepherd-element[data-popper-placement="top"] {
    margin-top: -12px;
}

.guide-dialog.shepherd-element[data-popper-placement="right"] {
    margin-left: 12px;
}

.guide-dialog.shepherd-element[data-popper-placement="bottom"] {
    margin-top: 12px;
}

.guide-dialog.shepherd-element[data-popper-placement="left"] {
    margin-left: -12px;
}

.guide-dialog.shepherd-element.visual-graph-link-focus-guide-dialog {
    margin-top: -52px;
}

.guide-copy-to-input-query-button,
.guide-copy-to-editor-query-button {
    color: var(--gw-button-secondary-color);
    background-color: var(--gw-shortcuts-secondary-button-background);
    border-color: var(--gw-button-secondary-border-color);
}
`, "",{"version":3,"sources":["webpack://./packages/root-config/src/vendor/shepherd-custom.css"],"names":[],"mappings":"AAAA;IACI,2DAA2D;IAC3D,2CAA2C;AAC/C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6DAA6D;IAC7D,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,+BAA+B;IAC/B,4CAA4C;IAC5C,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,6CAA6C;IAC7C,6BAA6B;IAC7B,+CAA+C;AACnD;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,6CAA6C;IAC7C,cAAc;IACd,sDAAsD;AAC1D;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,qDAAqD;AACzD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wDAAwD;IACxD,0DAA0D;AAC9D;;AAEA;;;CAGC;AACD;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,uCAAuC;IACvC,iEAAiE;IACjE,qDAAqD;AACzD","sourcesContent":[".onto-btn-primary.shepherd-button:hover {\n    background-color: var(--gw-button-primary-hover-background);\n    color: var(--gw-button-primary-hover-color);\n}\n\n.onto-btn-primary.shepherd-button[disabled]{\n    opacity: 0.5;\n}\n\n.onto-btn-secondary.shepherd-button:hover {\n    background-color: var(--gw-button-secondary-hover-background);\n    color: var(--gw-button-secondary-hover-color);\n}\n\n.shepherd-element {\n    border-radius: 0;\n    max-width: 500px;\n}\n\n.shepherd-content {\n    border-radius: 0;\n}\n\n.shepherd-header {\n    border-radius: 0;\n}\n\n.shepherd-header h3 {\n    padding-left: 0.5em;\n}\n\n.shepherd-text {\n    text-align: center;\n    min-height: 90px;\n    margin-top: 10px;\n    overflow-wrap: break-word;\n    color: var(--gw-dialog-color);\n}\n\n.shepherd-text ol, .shepherd-text ul {\n    text-align: left;\n}\n\n.shepherd-text code {\n    text-align: left;\n    display: block;\n    height: 120px;\n    margin-top: 0.5em;\n    color: var(--gw-secondary-base);\n    background-color: var(--gw-tertiary-lighter);\n    overflow: auto;\n    white-space: pre-wrap;\n}\n\n.shepherd-has-title .shepherd-content {\n    background-color: var(--gw-dialog-background);\n    color: var(--gw-dialog-color);\n    border: 1px solid var(--gw-dialog-border-color);\n}\n\n.shepherd-has-title .shepherd-content .shepherd-header {\n    padding-top: 0.5em;\n    padding-bottom: 0.5em;\n    background-color: var(--gw-dialog-background);\n    color: inherit;\n    border-bottom: 1px solid var(--gw-dialog-border-color);\n}\n\n.shepherd-has-title .shepherd-content .shepherd-title {\n    color: inherit;\n}\n\n.shepherd-has-title .shepherd-content .shepherd-cancel-icon {\n    color: var(--gw-dialog-color) !important;\n}\n\n.shepherd-has-title .shepherd-content .shepherd-cancel-icon:hover {\n    color: var(--gw-button-primary-background) !important;\n}\n\n.shepherd-footer {\n    padding-bottom: 0.5em;\n}\n\n.shepherd-arrow:before {\n    background-color: var(--gw-dialog-background) !important;\n    border: 1px solid var(--gw-dialog-border-color) !important;\n}\n\n/*\n  Moves the 'Previous' button to the left when it's the only button shown.\n  This avoids UX confusion, as primary actions ('Next') is usually on the right.\n*/\n.shepherd-footer:has(> .shepherd-prev-button:only-child) {\n    justify-content: flex-start;\n}\n\n.shepherd-progress {\n    display: block;\n    text-align: right;\n    padding-right: 1em;\n    font-size: 0.9em;\n}\n\n.shepherd-code {\n    position: relative;\n}\n\n.shepherd-code button {\n    position: absolute;\n    bottom: 5px;\n    right: 20px;\n}\n\n.guide-dialog.shepherd-element[data-popper-placement=\"top\"] {\n    margin-top: -12px;\n}\n\n.guide-dialog.shepherd-element[data-popper-placement=\"right\"] {\n    margin-left: 12px;\n}\n\n.guide-dialog.shepherd-element[data-popper-placement=\"bottom\"] {\n    margin-top: 12px;\n}\n\n.guide-dialog.shepherd-element[data-popper-placement=\"left\"] {\n    margin-left: -12px;\n}\n\n.guide-dialog.shepherd-element.visual-graph-link-focus-guide-dialog {\n    margin-top: -52px;\n}\n\n.guide-copy-to-input-query-button,\n.guide-copy-to-editor-query-button {\n    color: var(--gw-button-secondary-color);\n    background-color: var(--gw-shortcuts-secondary-button-background);\n    border-color: var(--gw-button-secondary-border-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
